import type { TRUETENANT } from './types'

export const truetenant: TRUETENANT = {
	marketing: {
		benefits: [
			{
				description:
					'Complete your rental qualifications once and share your verified profile anywhere you apply',
				icon: 'update',
				title: 'Verified In Minutes',
			},
			{
				description:
					'Bank-level security with strict privacy controls, so you decide exactly what gets shared and when',
				icon: 'lock-closed',
				title: 'Your Data, Protected',
			},
			{
				description:
					'Built to meet rental laws and compliance standards, your verified profile proves eligibility upfront',
				icon: 'verified',
				title: 'Fair & Compliant',
			},
		],
		description: {
			meta: 'Verify your identity, income, and background with TrueTenant and create a universal rental profile you can share anywhere. Get approved faster with one trusted verification.',
			title:
				'TrueTenant: Fast, Secure Tenant Verification & Universal Rental Profile',
			short: "TrueTenant: The last rental application you'll ever fill out",
		},
		features: [
			{
				description:
					'AI-powered tenant screening that analyzes income, rental history, and identity to deliver comprehensive rankings within seconds',
				icon: 'magnifying-glass',
				title: 'Tenant Screening',
			},
			{
				description:
					'Streamlined rent collection with automated reminders and secure payment processing',
				icon: 'file-text',
				title: 'Rent Collection',
			},
			{
				description:
					'Generate professional leases instantly with customizable templates that meet legal requirements',
				icon: 'file-text',
				title: 'Lease Generator',
			},
			{
				description:
					'Comprehensive analytics and reports to track property performance and tenant insights',
				icon: 'bar-chart',
				title: 'Analytics & Reports',
			},
			{
				description:
					'Create a verified profile once and use it to apply for multiple rentals instantly',
				icon: 'person',
				title: 'Verified Profile',
			},
		],
		hero: {
			main: "The Last, Rental Application You'll Ever Fill Out",
			sub: 'Ready to streamline your rental application process?',
		},
		name: 'TrueTenant',
		personas: [
			{
				description:
					'Build credibility and speed up the rental application process with a verified profile',
				icon: 'person',
				title: 'Tenants',
			},
			{
				description:
					'Find qualified tenants faster with AI-powered screening and comprehensive verification',
				icon: 'home',
				title: 'Landlords',
			},
			{
				description:
					'Manage properties efficiently with automated rent collection, lease generation, and analytics',
				icon: 'update',
				title: 'Property Managers',
			},
		],
	},
	websiteDomain: 'truetenant.ai',
}
